module.exports = __webpack_public_path__ + "img/Close.45d607ba.svg";